// Aquí está el slice de evento
import { createSlice } from "@reduxjs/toolkit";
// import { crearEvento } from "./eventoThunks";

const initialState = {
  infoEvento: null,
  failureEvento: false,
  errorEvento: null,
  isLoadingEvento: false,
  // Estados para estadísticas del dashboard
  statsInfoEvento: null,
  statsTipoTickets: [],
  statsQuickStats: null,
  statsHistorialDeEntradas: null,
  statsTicketsVendidos: null,
  statsAmbassadors: null,
  activeAmbassadors: null,
  // Estados para embajadores del evento (público)
  ambassadoresEvento: [],
  ambassadoresLoading: false,
  ambassadoresHasNextPage: false,
  ambassadoresCurrentPage: 0,
  ambassadoresTotalPages: 0,
  // Estados para informes fiscales
  informesFiscales: [],
  generandoInforme: false,
  errorInforme: null,
};

const eventoSlice = createSlice({
  name: "evento",
  initialState,
  reducers: {
    eventoSuccess: (state, action) => {
      // Actualizar estado según el payload recibido
      if (action.payload.infoEvento !== undefined) {
        state.infoEvento = action.payload.infoEvento;
      }
      if (action.payload.statsInfoEvento !== undefined) {
        state.statsInfoEvento = action.payload.statsInfoEvento;
      }
      if (action.payload.statsTipoTickets !== undefined) {
        state.statsTipoTickets = action.payload.statsTipoTickets;
      }
      if (action.payload.statsQuickStats !== undefined) {
        state.statsQuickStats = action.payload.statsQuickStats;
      }
      if (action.payload.statsHistorialDeEntradas !== undefined) {
        state.statsHistorialDeEntradas = action.payload.statsHistorialDeEntradas;
      }
      if (action.payload.statsTicketsVendidos !== undefined) {
        state.statsTicketsVendidos = action.payload.statsTicketsVendidos;
      }
      if (action.payload.statsAmbassadors !== undefined) {
        state.statsAmbassadors = action.payload.statsAmbassadors;
      }
      if (action.payload.activeAmbassadors !== undefined) {
        state.activeAmbassadors = action.payload.activeAmbassadors;
      }
      if (action.payload.ambassadoresEvento !== undefined) {
        const { ambassadors, pagination } = action.payload.ambassadoresEvento;
        const isFirstPage = action.payload.isFirstPage;
        
        // Si es página 1, reemplazar; si es > 1, agregar al final (infinite scroll)
        if (isFirstPage) {
          state.ambassadoresEvento = ambassadors;
        } else {
          state.ambassadoresEvento = [...state.ambassadoresEvento, ...ambassadors];
        }
        
        // Actualizar metadata de paginación
        state.ambassadoresCurrentPage = pagination.currentPage;
        state.ambassadoresTotalPages = pagination.totalPages;
        state.ambassadoresHasNextPage = pagination.hasNextPage;
        state.ambassadoresLoading = false;
      }
      
      state.failureEvento = false;
      state.isLoadingEvento = false;
    },
    eventoFailure: (state, action) => {
      state.failureEvento = true;
      state.isLoadingEvento = false;
      state.errorEvento = action.payload; // mensaje de errorEvento
    },
    setInformesFiscales: (state, action) => {
      state.informesFiscales = action.payload;
    },
    setGenerandoInforme: (state, action) => {
      state.generandoInforme = action.payload;
    },
    setErrorInforme: (state, action) => {
      state.errorInforme = action.payload;
    },
    eventoReset: (state) => {
      state.infoEvento = null;
      state.failureEvento = false;
      state.errorEvento = null;
      state.isLoadingEvento = false;
      state.statsInfoEvento = null;
      state.statsTipoTickets = [];
      state.statsQuickStats = null;
      state.statsHistorialDeEntradas = null;
      state.statsTicketsVendidos = null;
      state.statsAmbassadors = null;
      state.activeAmbassadors = null;
      state.ambassadoresEvento = [];
      state.ambassadoresLoading = false;
      state.ambassadoresHasNextPage = false;
      state.ambassadoresCurrentPage = 0;
      state.ambassadoresTotalPages = 0;
    },
  },
});


export const {
  eventoSuccess,
  eventoFailure,
  eventoReset,
  setInformesFiscales,
  setGenerandoInforme,
  setErrorInforme,
} = eventoSlice.actions;
export default eventoSlice.reducer;